module.exports = __webpack_public_path__ + "static/img/spice.1ac0edf3.png";